import {
	BusinessWithSubscriptionStateModel,
	FirestoreStateBaseForBusinessWithSubscription,
} from '@state/FirestoreStateBaseForBusiness';
import { DocumentRequest } from '@models/document-requests';
import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { DEFAULT_STATE_BASE } from '@state/FirestoreStateBase';
import * as DocumentRequestsActions from './document-requests.actions';
import { where } from '@angular/fire/firestore';
import { DocumentRequestsRepo } from '@repos/document-requests/document-requests.repo';

export interface DocumentRequestsStateModel
	extends BusinessWithSubscriptionStateModel {
	items: DocumentRequest[];
	requestCreationInProgress: boolean;
}

const DEFAULT_STATE: DocumentRequestsStateModel = {
	...DEFAULT_STATE_BASE,
	items: [],
	requestCreationInProgress: false,
};

@State<DocumentRequestsStateModel>({
	name: 'documentRequests',
	defaults: DEFAULT_STATE,
})
@Injectable({
	providedIn: 'root',
})
export class DocumentRequestsState extends FirestoreStateBaseForBusinessWithSubscription<
	DocumentRequest,
	DocumentRequestsStateModel
> {
	constructor(private documentRequestsRepo: DocumentRequestsRepo) {
		super(
			() => 'documentRequests',
			(payload) => ({ items: payload as DocumentRequest[] }),
			() => DEFAULT_STATE,
			() => [where('businessId', '==', this.businessId)],
		);
	}

	@Action(DocumentRequestsActions.Create)
	async Create(
		ctx: StateContext<DocumentRequestsStateModel>,
		action: DocumentRequestsActions.Create,
	) {
		const state = ctx.getState();
		ctx.patchState({ requestCreationInProgress: true });

		try {
			const items = [...state.items, action.payload];
			await this.repo.CreateOrMerge(action.payload.id, action.payload);
			ctx.patchState({ items });
		} finally {
			ctx.patchState({ requestCreationInProgress: false });
		}
	}

	@Action(DocumentRequestsActions.Update)
	update(
		ctx: StateContext<DocumentRequestsStateModel>,
		action: DocumentRequestsActions.Update,
	) {
		this.repo.CreateOrMerge(action.payload.id, action.payload);

		const state = ctx.getState();
		const items = state.items.map((item) =>
			item.id === action.payload.id ? action.payload : item,
		);
		ctx.patchState({ items });
	}

	@Action(DocumentRequestsActions.Delete)
	delete(
		ctx: StateContext<DocumentRequestsStateModel>,
		action: DocumentRequestsActions.Delete,
	) {
		const state = ctx.getState();
		const items = state.items.filter((item) => item.id !== action.payload);
		ctx.patchState({ items });
	}
}
